module.exports = __webpack_public_path__ + "static/media/logo.a049476f.png";